import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'lib/api';
import { getUserId } from 'lib/msal';
import { reject } from 'lodash';
export var SCHEDULE_TODAY = 'SCHEDULE_GET_SCHEDULE_TODAY';
export var CLEAR_SCHEDULE_FROM_STORE = 'CLEAR_SCHEDULE_FROM_STORE';
export var GET_SCHEDULE_ITEM = 'SCHEDULE_GET_SCHEDULE_ITEM';
export var GET_SCHEDULES_BY_ID = 'SCHEDULE_GET_SCHEDULE_ITEMS';
export var GET_SCHEDULE_FOR_USER = 'SCHEDULE_GET_USER_SCHEDULE';
export var GET_SCHEDULE_FOR_GROUPS = 'GET_SCHEDULE_FOR_GROUPS';
export var CLEAR_SCHEDULE_ITEM = 'SCHEDULE_CLEAR_SCHEDULE_ITEM';
export var GET_ACTIVITIES_FOR_USER = 'GET_ACTIVITIES_FOR_USER';
export var GET_ACTIVITIES_FOR_GROUPS = 'GET_ACTIVITIES_FOR_GROUPS';
export var CLEAR_ACTIVITIES_FOR_OTHERS_STORE = 'CLEAR_ACTIVITIES_FOR_OTHERS_STORE';
export var CLEAR_SEARCHED_SCHEDULES = 'CLEAR_SEARCHED_SCHEDULES';
export var GET_ACTIVITIES_BY_ID = 'GET_ACTIVITIES_BY_ID';
export var SUBMIT_CALENDAR_EVENT = 'SCHEDULE_CREATE_CALENDAR_EVENT';
export var UPDATE_CALENDAR_EVENT = 'SCHEDULE_UPDATE_CALENDAR_EVENT';
export var DELETE_CALENDAR_EVENT = 'SCHEDULE_DELETE_CALENDAR_EVENT';
export var GET_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE = 'GET_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE';
export var CLEAR_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE = 'CLEAR_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE';
export var getSchedule = function getSchedule(start, end) {
  return {
    type: SCHEDULE_TODAY,
    payload: new Promise(function (resolve) {
      api.get("schedule?starttime=".concat(start, "&endtime=").concat(end)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getScheduleForUser = function getScheduleForUser(user, start, end) {
  return {
    type: GET_SCHEDULE_FOR_USER,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (getUserId() == user) {
                  api.get("schedule?starttime=".concat(start, "&endtime=").concat(end)).then(function (response) {
                    resolve({
                      userId: user,
                      documents: response.data
                    });
                  })["catch"](function (e) {
                    console.log(e);
                  });
                } else {
                  api.get("schedule/user/".concat(user, "/?starttime=").concat(start, "&endtime=").concat(end)).then(function (response) {
                    resolve({
                      userId: user,
                      documents: response.data
                    });
                  })["catch"](function (e) {
                    console.log(e);
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }())
  };
};
export var getActivitiesForMe = function getActivitiesForMe(start, end, userId) {
  return {
    type: GET_ACTIVITIES_FOR_USER,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api.get("users/me/activities?startDate=".concat(start, "&endDate=").concat(end)).then(function (response) {
                  resolve({
                    userId: userId,
                    documents: response.data
                  });
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }())
  };
};
export var getActivitiesById = function getActivitiesById(userId, start, end) {
  return {
    type: GET_ACTIVITIES_BY_ID,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                api.get("activities/users/".concat(userId, "?startDate=").concat(start, "&endDate=").concat(end)).then(function (response) {
                  resolve({
                    documents: response.data
                  });
                })["catch"](function (e) {
                  console.log(e);
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }())
  };
};
export var getScheduleForGroups = function getScheduleForGroups(start, end, section) {
  return {
    type: GET_SCHEDULE_FOR_GROUPS,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                api.post("schedule/users?starttime=".concat(start, "&endtime=").concat(end), section).then(function (response) {
                  resolve({
                    documents: response.data
                  });
                })["catch"](function (e) {
                  console.log(e);
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }())
  };
};
export var getActivitesForGroups = function getActivitesForGroups(start, end, section) {
  return {
    type: GET_ACTIVITIES_FOR_GROUPS,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                api.post("activities/sections?startDate=".concat(start, "&endDate=").concat(end), section).then(function (response) {
                  resolve({
                    documents: response.data
                  });
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }())
  };
};
export var getScheduleItem = function getScheduleItem(id) {
  return {
    type: GET_SCHEDULE_ITEM,
    payload: new Promise(function (resolve) {
      api.get("schedule/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getScheduleItems = function getScheduleItems(id) {
  return {
    type: GET_SCHEDULES_BY_ID,
    payload: new Promise(function (resolve) {
      api.get("schedule/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var clearScheduleItem = function clearScheduleItem() {
  return {
    type: CLEAR_SCHEDULE_ITEM,
    payload: true
  };
};
export var clearSearchedSchedules = function clearSearchedSchedules() {
  return {
    type: CLEAR_SEARCHED_SCHEDULES,
    payload: true
  };
};
export var clearActivitesForOther = function clearActivitesForOther() {
  return {
    type: CLEAR_ACTIVITIES_FOR_OTHERS_STORE,
    payload: []
  };
};
export var clearScheduleFromStore = function clearScheduleFromStore() {
  return {
    type: CLEAR_SCHEDULE_FROM_STORE,
    payload: []
  };
};
export var submitCalendarEvent = function submitCalendarEvent(values) {
  return {
    type: SUBMIT_CALENDAR_EVENT,
    payload: new Promise(function (resolve, reject) {
      api.post("schedule", values).then(function (response) {
        // TODO: Add error here
        if (false) {
          reject(response.data);
        } else {
          resolve(response.data);
        }
      });
    })
  };
};
export var updateCalendarEvent = function updateCalendarEvent(values) {
  return {
    type: UPDATE_CALENDAR_EVENT,
    payload: new Promise(function (resolve, reject) {
      api.put("schedule", values).then(function (response) {
        if (false) {
          reject(response);
        } else {
          console.log(response.data);
          resolve(response.data);
        }
      });
    })
  };
};
export var deleteCalendarEvent = function deleteCalendarEvent(id) {
  return {
    type: DELETE_CALENDAR_EVENT,
    payload: new Promise(function (resolve, reject) {
      api["delete"]("schedule/".concat(id)).then(function (response) {
        if (response.status != 200) reject(0);
        resolve(1);
      });
    })
  };
};
export var getNotReportedSchedulePositions = function getNotReportedSchedulePositions(roleId, startDate, endDate, callback) {
  return {
    type: GET_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE,
    payload: new Promise(function (resolve) {
      api.get("schedule/notreported?roleId=".concat(roleId, "&startDate=").concat(startDate, "&endDate=").concat(endDate)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var clearNotReportedSchedulePositions = function clearNotReportedSchedulePositions() {
  return {
    type: CLEAR_SCHEDULE_POSITION_WITH_NO_REPORTED_ATTENDANCE,
    payload: []
  };
};